import React from "react";

export const Patients = () => {
  return (
    <div>
      <h1 className="text-center">Patient Page</h1>
    </div>
  );
};
